import { VuexModule,getModule, Module, Mutation, Action } from 'vuex-module-decorators';
import store from './index'
import logmessage from '@/model/logmessage';
import logsService from '@/services/logs.service';


@Module({ name:"Logs", dynamic:true, store})
class Logs extends VuexModule {
  public messages:logmessage[]=[];

@Mutation
public addMessageMutation(message:logmessage){
   this.messages.push(message);     
}

@Mutation
public clearAllMessagesMutation(){
    this.messages.splice(0);
}

@Action
public getLogMessagesAction(token:string):void{
  console.log("getLogMessages")
  this.clearAllMessagesMutation();
    logsService.gelogmessages(token, 0,0,"DEBUG",(data:string)=>{
        const message:logmessage = JSON.parse(data);
        console.log("GETLOGMESSAGES:",message)      
        this.addMessageMutation(message)
    },(data:string)=>{
      console.log(data);
    });
}
get getAllMessages():logmessage[] { 
  return this.messages;
}
}

export default getModule(Logs);